(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-section-full-screen-slide"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.original-section-full-screen-slide-box', {
  // direction: 'vertical',
  loop: true,
  effect: 'fade',
  pagination: {
    el: '.original-section-full-screen-slide-pagination',
    renderBullet: (index, className) => {
      // 各ページネーションの要素に、アニメーションを制御するためのSVG要素を追加
      return `<span class="${className}"><svg class="circle" width="19" height="19" viewBox="0 0 19 19"><circle cx="9.5" cy="9.5" r="9"></circle></svg></span>`;
    },
    clickable: true,
  },
  navigation: {
    nextEl: '.original-section-full-screen-slide .swiper-button-next',
    prevEl: '.original-section-full-screen-slide .swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  speed: 2000,
  autoplay: {
    delay: 9000, // スライドの表示時間
    disableOnInteraction: false, // ユーザー操作後も自動再生を続ける
  },
});

// スライドが切り替わったときのイベント
swiper.on('slideChangeTransitionEnd', function () {
  // すべてのページネーションのアニメーションをリセット
  document.querySelectorAll('.original-section-full-screen-slide-pagination .swiper-pagination-bullet svg circle').forEach(circle => {
    circle.style.animation = 'none'; // 現在のアニメーションを停止
    void circle.offsetWidth; // 強制的にリフロー（アニメーションを再適用するために必要）
  });

  // アクティブなページネーションのサークルにアニメーションを再適用
  const activeBullet = document.querySelector('.original-section-full-screen-slide-pagination .swiper-pagination-bullet-active svg circle');
  if (activeBullet) {
    activeBullet.style.animation = 'circle 9s linear forwards'; // CSSアニメーションの時間と合わせる
  }
});

// Swiperの初期化時に最初のスライドのアニメーションを開始
swiper.on('init', function () {
  const initialActiveBullet = document.querySelector('.original-section-full-screen-slide-pagination .swiper-pagination-bullet-active svg circle');
  if (initialActiveBullet) {
    initialActiveBullet.style.animation = 'circle 9s linear forwards';
  }
});

// ページネーションのクリックイベントでアニメーションを再開
swiper.pagination.bullets.forEach((bullet, index) => {
  bullet.addEventListener('click', () => {
    // クリックされたページネーション以外のすべてのアニメーションをリセット
    document.querySelectorAll('.original-section-full-screen-slide-pagination .swiper-pagination-bullet svg circle').forEach(circle => {
      circle.style.animation = 'none';
      void circle.offsetWidth;
    });
    // クリックされたページネーションのアニメーションを開始
    const clickedBulletCircle = bullet.querySelector('svg circle');
    if (clickedBulletCircle) {
      clickedBulletCircle.style.animation = 'circle 9s linear forwards';
    }
  });
});


// 一時停止・再生ボタンのイベントリスナー
document.querySelector(".swiper_pause").addEventListener("click", function(){
  const allCircleElements = document.querySelectorAll('.original-section-full-screen-slide-pagination .swiper-pagination-bullet svg circle');

  if(this.classList.contains("paused")){
    // 再生状態にする
    swiper.autoplay.start(); // スライダーの自動再生を再開
    this.classList.remove("paused"); // "paused" クラスを削除

    // ページネーションのアニメーションを再開
    allCircleElements.forEach(circle => {
      circle.style.animationPlayState = 'running';
    });

  }else{
    // 一時停止状態にする
    swiper.autoplay.stop(); // スライダーの自動再生を停止
    this.classList.add("paused"); // "paused" クラスを付与

    // ページネーションのアニメーションを一時停止
    allCircleElements.forEach(circle => {
      circle.style.animationPlayState = 'paused';
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-section-slide-multi"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.original-section-slide-multi-box',{
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    reverseDirection: false,
  },
  speed: 600,
  loop: true,
  slidesPerView: 2,
  spaceBetween: 4,
  centeredSlides: true,
  breakpoints: {
    200: {
      slidesPerView: 1.1,
      spaceBetween: 2
    },    
    700: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 2,
    }
  },
  pagination: {
    el: '.original-section-slide-multi-pagination',
    clickable: true,
  },
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
disabledClass:'disabled'//前や次にスライドがない場合にボタンに付与するクラスを指定
      }
});

  } catch(e) { console.error(e); }
})();
})();
